import { Doughnut ,Pie} from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme,
  Grid,
  IconButton,
  CircularProgress
} from '@mui/material';
import { Male, Female, Refresh } from '@mui/icons-material';
import { useEffect, useState,useRef } from 'react';
import PropTypes from 'prop-types';
import BasicMenu from 'src/components/common/BasicMenu';
import { saveAs } from 'file-saver';

const Traffic = ({ serverError, chartOptions, displayComponent, ...props }) => {
  const theme = useTheme();
  const chartRefGender = useRef(null),
    chartRefRelation = useRef(null);
  const [genderData, setGenderData] = useState({});
  const [relationData, setRelationData] = useState({});
  const [activeChart, setActiveChart] = useState(0);

  const display = Object.assign(
    { relation: true, gender: true },
    displayComponent
  );

  const MenuList = [
    {
      id: 0,
      title: 'Gender'
    },
    {
      id: 1,
      title: 'Relation'
    }
  ];
  let genderImage = null,
    relationImage = null;
  const paletteLabel = Object.keys(colors).slice(1);

  const options = {
    animation: {
      animateRotate: false,
      animateScale: false,
      onComplete: () => {
        if (chartRefGender.current) {
          console.log('genderimage', genderImage === null);
          genderImage =
            genderImage === null
              ? chartRefGender.current.toBase64Image('image/jpeg', 1)
              : genderImage;
        }
        if (chartRefRelation.current) {
          relationImage =
            relationImage === null
              ? chartRefRelation.current.toBase64Image('image/jpeg', 1)
              : relationImage;
        }
      }
    },
    onClick: () => {
      saveAs(relationImage, `relation.jpg`);
    },
    cutout: 70,
    radius: '70%',
    maintainAspectRatio: false,
    responsive: true,
    // layout: { padding: 0 }, //default
    plugins: {
      legend: {
        display: true, //default
        labels: {
          boxWidth: 25
        }
      }
    }
    // tooltips: {
    //   backgroundColor: theme.palette.background.paper,
    //   bodyFontColor: theme.palette.text.secondary,
    //   borderColor: theme.palette.divider,
    //   borderWidth: 1,
    //   enabled: true,
    //   footerFontColor: theme.palette.text.secondary,
    //   intersect: false,
    //   mode: 'index',
    //   titleFontColor: theme.palette.text.primary
    // }
  };

  const changeType = (value) => {
    setActiveChart(value);
  };

  useEffect(() => {
    if (chartOptions.gender) {
      setGenderData({
        datasets: [
          {
            data: chartOptions.gender.data,
            backgroundColor: ['#7abfff', '#ffbfcb'],
            borderWidth: 1,
            hoverOffset: 2,
            borderColor: ['#2e9aff', '#ff8ca2']
          }
        ],
        labels: chartOptions.gender.labels
        // genderType: [
        //   {
        //     title: chartOptions.gender.labels[0],
        //     value: chartOptions.gender.data[0],
        //     icon: Male,
        //     color: '#7abfff'
        //   },
        //   {
        //     title: chartOptions.gender.labels[1],
        //     value: chartOptions.gender.data[1],
        //     icon: Female,
        //     color: '#ffbfcb'
        //   }
        // ]
      });
    } else {
      setGenderData({});
    }
    if (chartOptions.relation) {
      let relations = chartOptions.relation.map((each) => each.relation);
      let realtionColorPicker = paletteLabel
        .slice(0, relations.length * 2)
        .filter((each, idx) => idx % 2 == 0);
        relations =  relations.filter(each=>{
          if(each){
            console.log("filter", each)
            return each
          }
        })
      setRelationData({
        labels: relations,
        datasets: [
          {
            label: '# of Votes',
            data: chartOptions.relation.map((each) => each.count),
            backgroundColor: realtionColorPicker.map(
              (each) => colors[each][200]
            ),
            borderColor: realtionColorPicker.map((each) => colors[each][500]),
            borderWidth: 1,
            hoverOffset: 2
          }
        ]
      });
    } else {
      setRelationData({});
    }
  }, [chartOptions]);

  return (
    <Card {...props}>
      {display.gender && (
        <div>
          <CardHeader title="Gender-wise Order Count" />
          <Divider sx={{ mx: 2 }} />
          <CardContent
            sx={{ pb: 0 }}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Box
              sx={{
                height: 220,
                maxWidth: 340,
                position: 'relative'
              }}
              className={!genderData.datasets ? 'display-center' : ''}
            >
              {genderData.datasets ? (
                <Doughnut
                  data={genderData}
                  options={options}
                  ref={chartRefGender}
                />
              ) : !serverError ? (
                <CircularProgress disableShrink size={60} />
              ) : (
                <Grid container alignItems="center">
                  <Typography color="error">Something went wrong!!</Typography>
                  <IconButton onClick={props.onRefresh} size="small">
                    <Refresh color="primary" />
                  </IconButton>
                </Grid>
              )}
            </Box>
          </CardContent>
          <Grid xs={12} container>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                sx={{ fontSize: 12, textAlign: 'center' }}
              >
                {' '}
                Male:{' '}
                {chartOptions.gender &&
                chartOptions.gender.data &&
                chartOptions.gender.data.length == 2
                  ? chartOptions.gender.data[0]
                  : 0}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                sx={{ fontSize: 12, textAlign: 'center' }}
              >
                {' '}
                Female:{' '}
                {chartOptions.gender &&
                chartOptions.gender.data &&
                chartOptions.gender.data.length == 2
                  ? chartOptions.gender.data[1]
                  : 0}
              </Typography>
            </Grid>
          </Grid>
        </div>
      )}
      {display.relation && (
        <div>
          <CardHeader sx={{ pt: 2 }} title="Relation-wise Order Count" />
          <Divider sx={{ mx: 2 }} />
          <CardContent
            sx={{ pb: 0 }}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Box
              sx={{
                height: 270,
                maxWidth: 340
              }}
              className={!relationData.datasets ? 'display-center' : ''}
            >
              {relationData.datasets ? (
                <Doughnut
                  options={options}
                  data={relationData}
                  ref={chartRefRelation}
                />
              ) : !serverError ? (
                <CircularProgress disableShrink size={60} />
              ) : (
                <Grid container alignItems="center">
                  <Typography color="error">Something went wrong!!</Typography>
                  <IconButton onClick={props.onRefresh} size="small">
                    <Refresh color="primary" />
                  </IconButton>
                </Grid>
              )}
            </Box>
          </CardContent>
        </div>
      )}
    </Card>
  );
};

Traffic.propTypes = {
  onRefresh: PropTypes.func.isRequired
};

export default Traffic;
